export const ALAT_TERPASANG_OPTIONS = [
  "Endotracheal Tube (ETT)",
  "Tracheostomy Tube",
  "Nasogastric Tube (NGT)",
  "Gastrostomy Tube (G-Tube)",
  "Kateter Urine (Foley Catheter)",
  "Jalur Intravena (IV Line / Infus)",
  "Central Venous Catheter (CVC)",
  "Chest Tube (WSD)",
  "Nephrostomy Tube",
  "HD Cath",
  "AV Shunt"
];
